import CardContainer from "./components/card/CardContainer";
import Header from "./components/header/Header";
import "../src/styles/style.css";

function App() {
  return (
    <div className="container">
      <Header />
      <CardContainer />
    </div>
  );
}

export default App;
